import {useEffect, useState} from 'react';
import {Box, InputAdornment, Typography} from '@mui/material';
import {AurTextField} from '../common/aur-text-field/AurTextField';
import styles from '../../styles/components/clientdetails/clientDetailsStyle.module.scss';
import {t} from 'i18next';
import {ReactComponent as InfoIcon} from '../../assests/svg/info-outlined-red.svg';
import {isValidFileName} from '../../utils/utils';

const typographyValues = 'conciergeReports.file';

/**
 * Component for file rename box
 * @param props
 * @returns
 */
const FileRenameBox = (props: {
  fileName: string | null;
  handleFileName: (name: string) => void;
}) => {
  const {fileName, handleFileName} = props;
  const splitFileName = fileName?.split('.');
  const fileExtension = splitFileName?.splice(-1);
  const fileNameOnly = splitFileName?.join('.');

  const [inputBoxValue, setInputBoxValue] = useState(fileNameOnly);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    if (fileName) {
      setError(!isValidFileName(fileName));
    }
  }, [fileName]);

  const renameChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target;
    setError(!isValidFileName(value));
    setInputBoxValue(value);
    handleFileName(value ? value + '.' + fileExtension : '');
  };
  return (
    <Box className="">
      <AurTextField
        error={error}
        helperText={t('conciergeReports.file.rename.fileNameHelperText')}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Typography className="typo-text body2_size file-extension">
                .{fileExtension}
              </Typography>
              {error && <InfoIcon className="error-info-icon" />}
            </InputAdornment>
          ),
        }}
        data-testid="file-rename-box"
        name="name"
        onChange={renameChangeHandler}
        value={inputBoxValue}
        ariaLabel={t(`${typographyValues}.rename.inputLabel`)}
        label={t(`${typographyValues}.rename.inputLabel`)}
        variant="filled"
        className={`aur-textfield custom-text-field rename-file-text-field ${styles.fieldFocused} `}
      />
    </Box>
  );
};

export default FileRenameBox;
